import { fetchPlayerStats, fetchTeamStats } from '@apis/statistics';
import type { Order } from '@shared-types/common.types';
import type { RoundPhase } from '@shared-types/match.types';

export const getStats = (
  {
    endpoint,
    stats,
    order,
    phase,
    seasonYear,
    teamId,
    limit,
    offset = 0,
  }: {
    endpoint: 'player' | 'team';
    stats: string[];
    order: Order;
    phase: RoundPhase;
    seasonYear: string;
    teamId: string;
    limit: number;
    offset?: number;
  },
  signal: AbortSignal,
) => {
  const params = {
    competitionId: window.competitionId,
    seasonYear,
    stats,
    order,
    phase,
    teamId: teamId ? teamId : null,
    limit,
    offset,
  };

  return endpoint === 'player' ? fetchPlayerStats(params, signal) : fetchTeamStats(params, signal);
};
